export const fontEntries = [
    [
        "HYKaiTiS",
        {
            "name": "汉仪楷体",
            "familyName": "HYKaiTiS",
            "src": [
                "HYKaiTiS.woff"
            ]
        }
    ],
    [
        "HYQiHei",
        {
            "name": "汉仪旗黑",
            "familyName": "HYQiHei",
            "src": [
                "HYQH-55S.woff"
            ]
        }
    ],
    [
        "Lato",
        {
            "name": "Lato",
            "familyName": "Lato",
            "src": [
                "Lato-Regular.ttf"
            ]
        }
    ],
    [
        "SYZhongS",
        {
            "name": "思源宋体",
            "familyName": "SYZhongS",
            "src": [
                "SYZhongS.woff2"
            ]
        }
    ],
    [
        "YuewenFont",
        {
            "name": "Yuewen Font",
            "familyName": "Yuewen Font",
            "fallbackFamilyNames": [
                "YuewenFont"
            ],
            "src": [
                "YuewenFont-Regular.otf"
            ]
        }
    ]
];
export const urlMap = {
    "HYKaiTiS.woff": {
        "relative": "../assets/font/HYKaiTiS.woff",
        "node_module": "@tencent/ywwriter-design/assets/font/HYKaiTiS.woff",
        "cdn": "https://stawritecdn.yuewen.com/assets/design/fonts/HYKaiTiS.8ebd9b.woff"
    },
    "HYQH-55S.woff": {
        "relative": "../assets/font/HYQH-55S.woff",
        "node_module": "@tencent/ywwriter-design/assets/font/HYQH-55S.woff",
        "cdn": "https://stawritecdn.yuewen.com/assets/design/fonts/HYQH-55S.48aa7f.woff"
    },
    "Lato-Regular.ttf": {
        "relative": "../assets/font/Lato-Regular.ttf",
        "node_module": "@tencent/ywwriter-design/assets/font/Lato-Regular.ttf",
        "cdn": "https://stawritecdn.yuewen.com/assets/design/fonts/Lato-Regular.f5de2a.ttf"
    },
    "SYZhongS.woff2": {
        "relative": "../assets/font/SYZhongS.woff2",
        "node_module": "@tencent/ywwriter-design/assets/font/SYZhongS.woff2",
        "cdn": "https://stawritecdn.yuewen.com/assets/design/fonts/SYZhongS.b14a10.woff2"
    },
    "YuewenFont-Regular.otf": {
        "relative": "../assets/font/YuewenFont-Regular.otf",
        "node_module": "@tencent/ywwriter-design/assets/font/YuewenFont-Regular.otf",
        "cdn": "https://stawritecdn.yuewen.com/assets/design/fonts/YuewenFont-Regular.678a92.otf"
    }
};
export const fontTheme = {
    "HYKaiTiS": [
        "HYKaiTiS"
    ],
    "HYQiHei": [
        "HYQiHei"
    ],
    "Lato": [
        "Lato"
    ],
    "SYZhongS": [
        "SYZhongS"
    ],
    "YuewenFont": [
        "Yuewen Font",
        "YuewenFont"
    ]
};
export const fontMap = {
    "HYKaiTiS": "汉仪楷体",
    "HYQiHei": "汉仪旗黑",
    "Lato": "Lato",
    "SYZhongS": "思源宋体",
    "YuewenFont": "Yuewen Font"
};
